/* global AWIN */
import createAdapter from './createAdapter'
import { getItem, setItem, removeItem } from '../../storeManager'
import { environment } from 'js/config'
import { excludeVAT } from '../../utils'

export const awin = createAdapter(() => true, {
  trackPurchase(transactionId, coupon, orderValue, currency) {
    if (!getItem('state')) {
      throw new Error('awinAdapter.ts error: no state saved')
    }

    const { user: userState, locale: localeState } = JSON.parse(
      getItem('state') as string,
    )
    const awc = getItem('awinAwc')
    const userId = userState.profile.id || userState.limitedProfile.id
    const country = userState.profile.country || localeState.country
    let merchantId: string = '113414'

    const couponUpper = coupon ? coupon.toUpperCase() : ''
    const isAwinCoupon =
      couponUpper === 'AWINCA' ||
      couponUpper === 'AWINUS' ||
      awc?.toUpperCase() === 'AWINCA' ||
      awc?.toUpperCase() === 'AWINUS'

    if (userId && (awc || isAwinCoupon)) {
      if (coupon) {
        const couponUpper = coupon.toUpperCase()
        switch (couponUpper) {
          case 'AWINCA':
            merchantId = '119213'
            coupon = 'AwinCA'
            break
          case 'AWINUS':
            merchantId = '119217'
            coupon = 'AwinUS'
            break
        }
      } else if (awc) {
        const awcUpper = awc.toUpperCase()
        switch (awcUpper) {
          case 'AWINCA':
            merchantId = '119213'
            coupon = 'AwinCA'
            break
          case 'AWINUS':
            merchantId = '119217'
            coupon = 'AwinUS'
            break
        }
      } else {
        coupon = null
      }

      const amount = parseFloat(excludeVAT(orderValue, country)).toFixed(2)

      const pixelUrl =
        'https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=' +
        merchantId +
        '&amount=' +
        amount +
        '&ch=aw&parts=DEFAULT:' +
        amount +
        '&ref=' +
        transactionId +
        '&vc=' +
        (coupon || '') +
        '&cr=' +
        currency +
        '&testmode=' +
        (environment === 'production' ? 0 : 1)

      const awPixel = new Image(0, 0)
      awPixel.src = pixelUrl
      document.getElementsByTagName('body')[0].appendChild(awPixel)

      // Revert to original solution for the time being
      console.log('BF AW', window?.AWIN)
      AWIN.Tracking.Sale = {
        amount: '' + amount,
        channel: 'aw',
        orderRef: '' + transactionId,
        parts: 'DEFAULT:' + amount,
        currency: '' + currency,
        voucher: '' + (coupon || ''),
        test: '' + (environment === 'production' ? 0 : 1),
      }
      AWIN.Tracking.run()
      console.log('AF AW', AWIN?.Tracking)
      removeItem('awinAwc')
    }
  },
  saveId() {
    const awc = new URLSearchParams(document.location.search).get('awc')
    if (awc) {
      setItem('awinAwc', awc)
    }
  },
})
